<template>
  <div class="lesson-card">
    <p class="title">{{ item.name }}</p>
    <template v-for="(lesson, index) in lessons">
      <basis-list-item
        :key="index"
        class-type="lesson"
        :item="lesson"
        :to="toLesson(lesson)"
      >
        <template v-slot:title="{column}">
          {{ column.name }}
        </template>
        <template v-slot:worth="{column}">
          <div class="worth-wrapper">
            <div class="teacher info">讲师：<span>{{ teacher.name }}</span></div>
            <div class="time info">时长：<span>{{ column.videoDuration | secondToDate }}</span></div>
            <div class="character-counts info">范字：<span>{{ column.charactersCount }}</span></div>
          </div>
        </template>
      </basis-list-item>
    </template>
  </div>
</template>

<script>
import { BasisListItem } from '@/components/basis'
import { mapGetters } from 'vuex'

export default {
  name: 'LessonCard',
  components: { BasisListItem },
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  computed: {
    ...mapGetters(['teacher']),
    lessons () {
      return this.item.lessons || []
    }
  },
  methods: {
    toLesson (item) {
      const { id } = item
      const { teacherId, id: courseId } = this.$route.params
      return {
        name: 'lesson-id',
        params: {
          teacherId,
          courseId,
          id
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.lesson-card {
  .title {
    @include sc($font-size-lg, $color-text-heavy);
    margin-bottom: 10px;
    &::before {
      @include wh(6px, 6px);
      content: " ";
      display: inline-block;
      background-color: $color-text-active;
      transform: rotate(45deg);
      vertical-align: middle;
      margin: 0 4px;
    }
  }
  .basis-list-item {
    + .basis-list-item {
      margin-top: 16px;
    }
    .worth-wrapper {
      @include sc($font-size-sm, $color-text-light);
      font-weight: 400;
      .info {
        padding: 0;
        line-height: 18px;
        + .info {
          margin-top: 4px;
        }
        span {
          color: $color-text-medium;
        }
      }
    }
  }
}
</style>
